/**
 * Common constants used across the application
 */

/**
 * Coin Types
 */
export const SUI_TYPE_ARG = "0x2::sui::SUI"; 
export const USDC_COIN_TYPE = "0x5d4b302506645c37ff133b98c4b50a5ae14841659738d6d733d59d0d217a93bf::coin::COIN"; // wUSDC
export const WUSDC_COIN_TYPE = "0x5d4b302506645c37ff133b98c4b50a5ae14841659738d6d733d59d0d217a93bf::coin::COIN";

/**
 * Transaction Limits
 */
export const MAX_MERGE_COIN_OBJECTS = 512;

/**
 * Coin Decimals
 */
export const USDC_COIN_DECIMALS = 6;
export const WUSDC_COIN_DECIMALS = 6;
